/**
 * Texts for Training page
 */
export const trainingPageText = {
    title: 'Formação - CamAPS FX',
    titleMeta: 'Disponibilizamos formação online gratuita para utilizadores do CamAPS FX',
    descriptionMeta: 'O Cambridge Diabetes Education Programme disponibiliza formação certificada online gratuita para pessoas com diabetes tipo 1, pais e tutores, pessoal escolar e profissionais de saúde.',
    keywords: 'formação camaps, formação camaps fx,  ',
    localeMeta: 'pt_PT',
    mainHeader: 'Formação para profissionais de saúde',
    mainSubHeader: 'Apoie as pessoas que utilizam CamAPS FX com formação conduzida por especialistas.',
    gettingStartedHeader: 'Primeiros passos',
    step1Title: '<strong>Passo 1:</strong><br/>Descarregue a aplicação',
    step2Title: '<strong>Passo 2:</strong><br/>Crie uma conta',
    step3Title: '<strong>Passo 3:</strong><br/>Inicie a formação essencial na aplicação',
    step4Title: '<strong>Passo 4:</strong><br/>Emparelhe a bomba e o CGM escolhidos (com a aprovação da sua equipa de diabetes) ou explore a aplicação com o <strong>Modo virtual</strong>',
    videoSrc: '/video/In-app training loop_1.mp4',
    certifiedTrainingTitle: 'Formação certificada',
    trainingHeader: 'Formação certificada',
    trainingHeader_2: 'Para profissionais de saúde',
    trainingHeader_3: 'Formação para utilizadores',
    trainingHeaderText: 'Formação online GRATUITA sobre o CamAPS FX, disponibilizada pelo Cambridge Diabetes Education Programme (CDEP).',
    websiteLink: 'https://www.camdiabtraining.com/account-sign-in.html',
    websiteLinkHeading: 'Formação CDEP',
    getTrained: 'Fazer a formação',
    trainingHeaderIat: 'Formação CamAPS FX',
    trainingHeaderTextIat: 'Conclua a formação essencial na aplicação antes de utilizar a aplicação CamAPS FX.',
    trainingSubHeaderOneIat: 'Primeiros passos',
    trainingSubTextOneIat: 'Descarregue a aplicação CamAPS FX. <br>Crie uma conta para iniciar a formação.',
    trainingSubHeaderTwoIat: 'Precisa de ajuda para instalar a aplicação?',
    trainingParaTwoStartIat: 'Visite a nossa secção de',
    trainingParaTwoEndIat: 'para obter orientações.',
    websiteLinkHeadingSupportIat: 'Apoio',
    trainingSubHeaderThreeIat: 'Recursos adicionais',
    animationsYpsoPumpText: 'Animações (YpsoPump)',
    animationsAndText: 'e',
    animationsDanaText: 'Animações (bomba Dana)',
    animationsFurtherText: 'Aprenda através de guias visuais passo a passo.',
    webinarsText: 'Webinars',
    webinarsFurtherText: 'Assista a sessões orientadas por especialistas sobre a utilização da aplicação.',
    websiteAnimationsYpsoPumpLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    websiteAnimationsDanaLink: 'https://www.camdiabtraining.com/view/25/Dana-insulin-pump-users.htm',
    websiteWebinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
};
